export default __webpack_public_path__ + "static/media/japantrad11.d703f6bd.png";